import React from "react";
import SanDiegoSunsetPage from "./SanDiegoSunsetPage";

export default function ChowCall() {
  return <SanDiegoSunsetPage eventName="San Diego Chow Call" pageTitle="San Diego Chow Call" />;
}
